module.exports = __webpack_public_path__ + "static/media/selfie_placeholder.f1b9626c.svg";